import { styled } from '@mui/material';
import React from 'react';
import { StyledBox } from './CategoriesDropdownStyles.js';

var SCROLLBAR_WIDTH = 20;
var containerWidth = Math.min(window.innerWidth * 0.9 - SCROLLBAR_WIDTH, 900);
var ExploreContainer = styled('div')({
    display: 'flex',
    paddingBottom: 45,
});
var ExploreColumn = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: 168,
        marginRight: 80,
        a: {
            color: theme.palette.primary.main,
            '&:hover': {
                textDecoration: 'underline !important',
            },
        },
        '.header': {
            fontSize: 16,
            fontWeight: 600,
            paddingTop: 5,
            paddingBottom: 5,
            color: theme.palette.primary.main,
        },
        '.text': {
            fontSize: 14,
            fontWeight: 500,
            paddingTop: 5,
            paddingBottom: 5,
            color: theme.palette.primary.main,
        },
    });
});
var PreviewContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: 322,
        a: {
            color: theme.palette.primary.main,
            '&:hover': {
                textDecoration: 'none !important',
                img: {
                    transform: 'scale(1.03)',
                },
            },
        },
        '.img_wrapper': {
            width: 322,
            height: 212,
            borderRadius: 5,
            overflow: 'hidden',
        },
        img: {
            width: 322,
            height: 212,
            objectFit: 'cover',
            transition: 'transform 0.4s ease-in-out',
        },
        '.title': {
            marginTop: 15,
            marginBottom: 5,
            fontSize: 18,
            fontWeight: 600,
            width: '100%',
            overflow: 'hidden',
            letterSpacing: 0.36,
            WebkitLineClamp: 1,
            lineHeight: 1.5,
            height: "1.5em",
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
        },
        '.subtitle': {
            fontSize: 14,
            fontWeight: 500,
            width: '100%',
            overflow: 'hidden',
            letterSpacing: 0.36,
            WebkitLineClamp: 2,
            lineHeight: 1.5,
            height: "3em",
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
        },
        '.link': {},
    });
});
var ExploreDropdown = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var nav = _a.nav, LinkComponent = _a.LinkComponent, onClose = _a.onClose;
    var collectionsNav = (_b = nav === null || nav === void 0 ? void 0 : nav.subNav) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.name === 'Collections'; });
    var editorialsNav = (_c = nav === null || nav === void 0 ? void 0 : nav.subNav) === null || _c === void 0 ? void 0 : _c.find(function (item) { return item.name === 'Editorials'; });
    var _h = React.useState(((_d = collectionsNav === null || collectionsNav === void 0 ? void 0 : collectionsNav.subNav) === null || _d === void 0 ? void 0 : _d[0]) || ((_e = editorialsNav === null || editorialsNav === void 0 ? void 0 : editorialsNav.subNav) === null || _e === void 0 ? void 0 : _e[0])), oneItem = _h[0], setOneItem = _h[1];
    return (React.createElement(StyledBox, { style: { width: containerWidth } },
        React.createElement(ExploreContainer, null,
            React.createElement("div", { style: { flex: 1, display: 'flex' } },
                ((_f = collectionsNav === null || collectionsNav === void 0 ? void 0 : collectionsNav.subNav) === null || _f === void 0 ? void 0 : _f.length) ? (React.createElement(ExploreColumn, null,
                    React.createElement("div", { className: "header" }, "Collections"), collectionsNav === null || collectionsNav === void 0 ? void 0 :
                    collectionsNav.subNav.slice(0, 6).map(function (item, idx) {
                        return (React.createElement(LinkComponent, { key: idx, to: item.route || '', style: { textDecoration: 'none' }, onClick: onClose },
                            React.createElement("div", { className: "text", onMouseEnter: function () {
                                    setOneItem(item);
                                } }, item.name)));
                    }))) : null,
                ((_g = editorialsNav === null || editorialsNav === void 0 ? void 0 : editorialsNav.subNav) === null || _g === void 0 ? void 0 : _g.length) ? (React.createElement(ExploreColumn, null,
                    React.createElement("div", { className: "header" }, "Editorials"), editorialsNav === null || editorialsNav === void 0 ? void 0 :
                    editorialsNav.subNav.slice(0, 6).map(function (item, idx) {
                        return (React.createElement(LinkComponent, { key: idx, to: item.route || '', style: { textDecoration: 'none' } },
                            React.createElement("div", { className: "text" }, item.name)));
                    }))) : null),
            oneItem ? (React.createElement(PreviewContainer, null,
                React.createElement(LinkComponent, { to: oneItem.route || '', style: { textDecoration: 'none' }, onClick: onClose },
                    React.createElement("div", null,
                        React.createElement("div", { className: "img_wrapper" },
                            React.createElement("img", { alt: "prev", src: oneItem === null || oneItem === void 0 ? void 0 : oneItem.previewImageUrl })),
                        React.createElement("div", { className: "title" }, oneItem.name),
                        React.createElement("div", { className: "subtitle" }, oneItem.metaDescription),
                        React.createElement("div", { className: "link" }))))) : null)));
};

export { ExploreDropdown as default };
//# sourceMappingURL=ExploreDropdown.js.map
